var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 121,
    viewBox: "0 0 244 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.13965 97.4496C2.33965 98.3296 3.75958 98.8796 5.19958 99.2896C8.49958 100.22 12.0996 100.41 15.3296 99.2496C18.5596 98.0896 21.3497 95.4496 22.1597 92.1096C22.9697 88.7696 21.4496 84.8696 18.3596 83.3796C16.5596 82.5196 14.4396 82.4996 12.5096 82.9996C11.5496 83.2396 10.6096 83.6196 9.86963 84.2696C7.54963 86.3196 8.31962 90.4496 10.7396 92.3796C13.1696 94.3096 16.5596 94.4996 19.6196 94.0496C22.3896 93.6396 25.2597 92.6896 27.0397 90.5196C27.9597 89.3996 28.5197 88.0396 28.9197 86.6496C29.7997 83.5896 29.9296 80.2196 28.7496 77.2596C27.7096 74.6496 25.5597 72.4196 22.9197 71.5596",
    stroke: "#FA5252",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2498 70.4096L23.1897 71.6396L24.4198 73.6996L23.0298 73.3496L21.7998 71.2896L23.8597 70.0596L25.2498 70.4096Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.73 101.01L150.54 112.48L161.07 107.77L151.73 101.01Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3997 10.2001L88.6797 0.830078L83.9297 11.3401L95.3997 10.2001Z",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.76 95.6997L200.75 97.1997C196.24 97.1997 197.09 93.7297 196.24 91.1797V14.4697H212.79V95.6997C211.28 101.72 203.76 95.6997 203.76 95.6997Z",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9703 98.7105H50.7103C48.8403 98.7105 47.3203 97.1905 47.3203 95.3205V15.9805H62.3604V95.3205C62.3604 97.1905 60.8503 98.7105 58.9703 98.7105Z",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.29 73.3798L228.57 64.0098L223.82 74.5198L235.29 73.3798Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.83 10.3697C170.43 10.3697 170.02 10.2197 169.71 9.90969C169.09 9.28969 169.09 8.28969 169.71 7.66969L172.61 4.76969C173.23 4.14969 174.23 4.14969 174.85 4.76969C175.47 5.38969 175.47 6.38969 174.85 7.00969L171.95 9.90969C171.63 10.2197 171.23 10.3697 170.83 10.3697Z",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.98 30.4102C242.626 30.4102 243.96 29.076 243.96 27.4302C243.96 25.7844 242.626 24.4502 240.98 24.4502C239.334 24.4502 238 25.7844 238 27.4302C238 29.076 239.334 30.4102 240.98 30.4102Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4714 109.725L75.5459 107.795L73.6161 112.72L78.5416 114.65L80.4714 109.725Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.84 23.4502H62.5898V84.6802H196.84V23.4502Z",
    fill: "#F03E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.77 77.0809H81.6504C79.4204 77.0809 77.6104 75.2709 77.6104 73.0409V33.9609C77.6104 31.7309 79.4204 29.9209 81.6504 29.9209H177.77C180 29.9209 181.81 31.7309 181.81 33.9609V73.0309C181.81 75.2709 180 77.0809 177.77 77.0809Z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.84 20.3604V93.6703C196.84 93.6703 196.99 99.4703 203.87 96.2003C203.87 96.2003 206.02 99.4703 212.24 98.3503",
    stroke: "#FA5252",
    strokeWidth: 1.5042,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.87 16.2305V74.7905",
    stroke: "#FA5252",
    strokeWidth: 1.5042,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.24 26.0801V98.3401",
    stroke: "#FA5252",
    strokeWidth: 1.5042,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 17.3506V90.6506",
    stroke: "#FA5252",
    strokeWidth: 1.5042,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0303 16.2305V74.7905",
    stroke: "#FA5252",
    strokeWidth: 1.5042,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3895 23.4502V95.7102C62.3895 95.7102 60.8695 99.8902 54.0195 98.3702",
    stroke: "#FA5252",
    strokeWidth: 1.5042,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.9 72.9001C142.034 72.9001 151.06 63.8741 151.06 52.7401C151.06 41.606 142.034 32.5801 130.9 32.5801C119.766 32.5801 110.74 41.606 110.74 52.7401C110.74 63.8741 119.766 72.9001 130.9 72.9001Z",
    stroke: "#FA5252",
    strokeWidth: 1.5042,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.9 52.7401L115.24 65.4301C112.33 61.8401 110.74 57.3601 110.74 52.7401C110.74 41.6801 119.84 32.5801 130.9 32.5801C141.96 32.5801 151.06 41.6801 151.06 52.7401C151.06 63.6801 142.16 72.7201 131.22 72.8901L130.9 52.7401Z",
    stroke: "#FA5252",
    strokeWidth: 1.5042,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.901 52.7404L118.2 63.0304C115.84 60.1204 114.561 56.4904 114.561 52.7404C114.561 43.7704 121.941 36.4004 130.901 36.4004C139.871 36.4004 147.24 43.7804 147.24 52.7404C147.24 61.6104 140.021 68.9404 131.151 69.0804L130.901 52.7404Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.95 59.7304C125.77 60.2504 127.66 61.0704 129.66 61.0704C133.35 61.0704 134.5 58.7204 134.46 56.9504C134.43 53.9804 131.75 52.7004 128.97 52.7004H127.37V50.5404H128.97C131.06 50.5404 133.71 49.4604 133.71 46.9504C133.71 45.2504 132.63 43.7504 129.98 43.7504C128.28 43.7504 126.65 44.5004 125.73 45.1604L124.98 43.0704C126.09 42.2504 128.25 41.4404 130.54 41.4404C134.72 41.4404 136.62 43.9204 136.62 46.5104C136.62 48.7004 135.31 50.5604 132.7 51.5104V51.5704C135.31 52.0904 137.44 54.0504 137.44 57.0304C137.44 60.4304 134.79 63.4004 129.69 63.4004C127.3 63.4004 125.21 62.6504 124.17 61.9604L124.95 59.7304Z",
    fill: "#FFE3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2897 28.4004H64.6797V36.0104H72.2897V28.4004Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2897 43.6104H64.6797V51.2204H72.2897V43.6104Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2897 58.8203H64.6797V66.4303H72.2897V58.8203Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2897 74.0303H64.6797V81.6403H72.2897V74.0303Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.75 28.4004H187.14V36.0104H194.75V28.4004Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.75 43.6104H187.14V51.2204H194.75V43.6104Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.75 58.8203H187.14V66.4303H194.75V58.8203Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.75 74.0303H187.14V81.6403H194.75V74.0303Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.21 36L180.29 40.57",
    stroke: "#FA5252",
    strokeWidth: 1.5042,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.04 68.7109L161.27 70.9909",
    stroke: "#FA5252",
    strokeWidth: 1.5042,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.21 51.2207L87.49 53.5007",
    stroke: "#FA5252",
    strokeWidth: 1.5042,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2998 32.9602L92.0598 32.2002",
    stroke: "#FA5252",
    strokeWidth: 1.5042,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 8.45996L32.3104 27.07",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5195 58.4804L26.6095 54.9004",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.1 6.2002L219.55 16.7302",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.29 115.69L179.68 96.1396",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.56 120.35L176.53 102.3",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRightImage);
export default __webpack_public_path__ + "static/media/videoRightImage.62447bb008976fcc2e9887593e5f1b20.svg";
export { ForwardRef as ReactComponent };